import { IColumnConfig } from "../../../components/ui/baseDataTable";
import { DisbursementRow, DisbursementsTableVM } from "../Logic/useDisbursementsTableVM";
import {
    DISBURSEMENT_BENEFICIARY_TYPE_OPTIONS,
    DISBURSEMENT_FUNDS_TRANSFER_MODE_OPTIONS,
} from "../Logic/disbursementMappings";
import { LAKH } from "../../../lib/utils";

const toLakhs = (amount?: number | null) =>
amount === null || amount === undefined ? null : amount / LAKH;

const fromLakhs = (amountInLakhs: number | null) =>
amountInLakhs === null ? null : amountInLakhs * LAKH;


export const makeDisbursementColumns = (
    vm: Pick<
      DisbursementsTableVM,
      "updateRow" | "isSaving" | "loanAccountOptions"
    >,
): IColumnConfig<DisbursementRow>[] => [
    {
      headerName: "Disbursement Date",
      field: "disbursement_date",
      type: "date",
      getValue: (row) => row.disbursement_date ?? "",
      isEditable: !vm.isSaving,
      onChange: vm.updateRow,
    },
    {
      headerName: "Loan Account No.",
      field: "loan_account_number",
      type: "select",
      getValue: (row) => row.loan_account_number ?? "",
      isEditable: !vm.isSaving,
      options: vm.loanAccountOptions,
      onChange: vm.updateRow,
      selectCellProps: {
        placeholder: "Loan Account",
        className: "px-0",
        labelClassName: "px-0 py-1 text-xs min-w-[150px]",
        dropdownClassName: "min-w-[220px]",
        showTitleSubTitle: true,
      },
      tableCellStyle: { minWidth: "24ch", width: "24ch", maxWidth: "24ch" },
      headerStyle: { minWidth: "24ch", width: "24ch", maxWidth: "24ch" },
    },
    {
      headerName: "Beneficiary Type",
      field: "beneficiary_type",
      type: "select",
      getValue: (row) => row.beneficiary_type,
      isEditable: !vm.isSaving,
      options: DISBURSEMENT_BENEFICIARY_TYPE_OPTIONS,
      onChange: vm.updateRow,
      selectCellProps: {
        placeholder: "beneficiary",
        className: "px-0",
        labelClassName: "px-0 py-1 text-xs min-w-[120px]",
      },
    },
    {
      headerName: "Funds Transfer Mode",
      field: "funds_transfer_mode",
      type: "select",
      getValue: (row) => row.funds_transfer_mode ?? null,
      isEditable: !vm.isSaving,
      options: DISBURSEMENT_FUNDS_TRANSFER_MODE_OPTIONS,
      onChange: vm.updateRow,
      selectCellProps: {
        placeholder: "mode",
        className: "px-0",
        labelClassName: "px-0 py-1 text-xs min-w-[120px]",
      },
    },
    {
      headerName: "Recipient",
      field: "recipient",
      type: "text",
      getValue: (row) => row.recipient ?? "",
      isEditable: !vm.isSaving,
      onChange: vm.updateRow,
      textCellProps: { truncateChars: 30, numberOfRows: 1 },
    },
    {
      headerName: "Amount (INR Lakhs)",
      field: "disbursement_amount",
      type: "number",
      getValue: (row) => toLakhs(row.disbursement_amount),
      isEditable: !vm.isSaving,
      onChange: (rowIndex, value) =>
        vm.updateRow(
            rowIndex,
            fromLakhs(value as number | null),
            "disbursement_amount",
        ),
    },
    {
      headerName: "Remarks",
      field: "remarks",
      type: "text",
      getValue: (row) => row.remarks ?? "",
      isEditable: !vm.isSaving,
      onChange: vm.updateRow,
      textCellProps: {
        truncateChars: 100,
        numberOfRows: 2,
        enableTooltip: true,
      },
    },
];